import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as JotaiProvider } from 'jotai';
import App from './App';
import { ErrorBoundary } from './lib/utils/errorBoundary';
import { AuthProvider } from './lib/auth/AuthContext';
import { queryClient } from './lib/utils/queryClient';
import { SEO } from './lib/utils/seo';
import { initializePerformanceMonitoring } from './lib/utils/performance';
import { APP_CONFIG } from './lib/utils/constants';
import './index.css';

// Initialize performance monitoring in production
if (APP_CONFIG.isProduction) {
  initializePerformanceMonitoring();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <JotaiProvider>
      <HelmetProvider>
        <SEO />
        <ErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <AuthProvider>
                <App />
                {APP_CONFIG.isDevelopment && <ReactQueryDevtools initialIsOpen={false} />}
              </AuthProvider>
            </BrowserRouter>
            <Toaster
              position="top-right"
              toastOptions={{
                className: 'bg-dark-card border border-dark-border text-dark-text',
                duration: 4000,
                style: {
                  background: '#1F2937',
                  color: '#F9FAFB',
                },
              }}
            />
          </QueryClientProvider>
        </ErrorBoundary>
      </HelmetProvider>
    </JotaiProvider>
  </StrictMode>
);